import { Box, FormControl } from "@mui/material";
import { CheckboxComponent } from "../../../inputComponents/CheckboxComponent";
import { MultipleSelectOptions } from "../../../selectComponents/MultipleSelectOptions";
import { useMemo } from "react";
import { FormikProps } from "formik";
import moment from "moment-timezone";
import { DateTimePicker } from "../../../selectComponents/DateTimePicker";

interface LeaderboardProps {
    formik: FormikProps<any>;
    isEdit: boolean;
    configCurrencies: string[];
    providedCurrencies: { currency_id: string; name: string }[];
    contentBoxClass?: string;
}
const Leaderboard = ({ formik, isEdit, configCurrencies, providedCurrencies, contentBoxClass }: LeaderboardProps) => {

    const disableLeaderboard = useMemo(() => {
        if (!formik.values.tempParams.currencyNames ||
            !formik.values.tempParams.currencyNames.filter((name: string) => name !== '').length) {
                formik.setFieldValue('tempParams.enableLeaderboard', false);
                formik.setFieldValue('tempParams.leaderboadCurrencyNames', []);
                return true
        }
        return false
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.tempParams.currencyNames]);

    const expiryAt = useMemo(() => {
        if (formik.values.leaderboard?.expiresAt) {
            return moment.utc(formik.values.leaderboard.expiresAt).local();
        }
    }, [formik.values.leaderboard?.expiresAt]);

    const leaderboardCurrencyNames = useMemo(() => {
        if (!isEdit) return [];

        const selectedIds = formik.values.leaderboard?.currencyIds;
        if (!selectedIds) return [];
        const currencyNames = providedCurrencies
            .filter((currency: { currency_id: string }) =>
                selectedIds.includes(currency.currency_id)
            )
            .map(({ name }) => name);
        formik.setFieldValue('tempParams.leaderboadCurrencyNames', currencyNames);
        return currencyNames;

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEdit, formik.values.leaderboard?.currencyIds, providedCurrencies]);

    const handleLeaderboardCurrencyIds = (values: string[]) => {
        const leaderboardCurrencyIds = values
            .map((selectedValue) => providedCurrencies.find((currency) => currency.name === selectedValue)?.currency_id)
            .filter(Boolean) as string[];

        formik.setFieldValue('leaderboard.currencyIds', leaderboardCurrencyIds);
    }

    const handleExpiryDate = (dateTimeValue: moment.Moment | null) => {
        if (dateTimeValue) {
            const dateTime = moment(dateTimeValue).utc().toDate().getTime();
            formik.setFieldValue('leaderboard.expiresAt', dateTime);
        } else {
            formik.setFieldValue('leaderboard.expiresAt', undefined)
        }
    };

    const handleLeaderboardOption = (event: any) => {
        const { checked } = event.target;
        if (!checked) {
            formik.setFieldValue('leaderboard', undefined);
            formik.setFieldValue('tempParams.leaderboadCurrencyNames', []);
        }
    }

    return (
        <Box className={contentBoxClass || 'functionality-items'}>
            <CheckboxComponent
                customBoxClass='currencies-checkbox'
                fieldName={'tempParams.enableLeaderboard'}
                label='Enable Leaderboard'
                labelVariant='body1'
                disabledCondition={disableLeaderboard}
                customAction={handleLeaderboardOption}
            ></CheckboxComponent>
            {formik.values.tempParams.enableLeaderboard && (
                <Box sx={{ marginTop: '20px' }}>
                    <MultipleSelectOptions
                        formik={formik}
                        preSelectedValue={isEdit && leaderboardCurrencyNames}
                        listOfOptions={isEdit ? configCurrencies : formik.values.tempParams.currencyNames}
                        formikFieldName={'tempParams.leaderboadCurrencyNames'}
                        inputLabel="Select Currencies"
                        customAction={handleLeaderboardCurrencyIds}
                        formControlClass={'currency-multiselect'}
                    />
                    <FormControl className="currency-multiselect">
                        <DateTimePicker
                            formik={formik}
                            formikFieldName="leaderboard.expiresAt"
                            datetimeValue={expiryAt}
                            pickerLabel="Expiry Date"
                            handleChange={handleExpiryDate}
                        />
                    </FormControl>
                </Box>
            )

            }
        </Box>
    )
}

export { Leaderboard };
